import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

//Components
import DataTable from "react-data-table-component";
import Layout from "../../../../Layout/Layout";

import ItemServiceV2 from "../../../../services/logistics_appCommonService";
import ItemServiceCustomer from "../../../../services/customer_appCommonService";
import LogisticsConstants from "../../../../common/LogisticsConstants";

//Serivce

import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import {
  formatDate,
  formatDateTime,
  getTodaysData,
  isValidNumber,
  validateContactNumber,
  validateName,
  validateRequired,
} from "../../../../common/Validations";
import toast from "react-hot-toast";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import { useDispatch } from "react-redux";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { addTransportNr } from "../../../../redux/feature/logistics_app/logisticsSlice";
import { useNavigate } from "react-router-dom";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import FuelEnteryFailureModal from "./FuelEnteryFailureModal";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_MAIL_ID: "Please enter a valid email address.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
};
const FuelEntryCreation = () => {
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Fuel Entry");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  /* pop failure modal data*/
  // eslint-disable-next-line
  const FailureFuelEntry = {
    title: "Warning",
    ErrorMsg: "",
  };
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getFailureModal] = useState(failureModalData);

  const [isCardVisible3, setCardVisible3] = useState(true);

  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };

  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureFuelEntry] = useState(false);

  // const [getDriveBankDetails, setDriveBankDetails] = useState([]);
  const [driverName1Desc, setDriverName1Desc] = useState("");
  const [maxOldReading, setMaxOldReading] = useState(null);
  const [getOldreadingValidation, setOldreadingValidation] = useState(false);

  const [formInputs, setFormInputs] = useState({
    filledDate: getTodaysData() || "",
    truckNo: "",
    driverName: "",
    driverContactNr: "",
    bunk: "",
    type: "",
    liters: "",
    price: "",
    totalAmount: "",
    paymentMode: "",
    // odometerReading: "",
    km: "",
    mileage: "",
    billDocument: "",
    oldReading: "",
    newReading: "",
    usageReading: "",
    fuelEnteryModal: "FUELUPDATED",

    fuelType: "Diesel",
    fuelTypeCode: "Diesel",
    fuelTypeDesc: "Diesel",
  });
  // console.log(">>formInputs", formInputs);
  const FuelType = [
    { id: 1, name: "Petrol" },
    { id: 2, name: "Diesel" },
  ];
  // const PaymentMode = [
  //   { id: 1, name: "Cash" },
  //   { id: 2, name: "UPI" },
  //   { id: 3, name: "Cards(Debit/Credit)" },
  // ];

  const bunk = [
    {
      id: 1,
      name: "Basaveshwara Fuels",
      code: "Basaveshwara Fuels",
      desc: "Basaveshwara Fuels",
    },
    { id: 2, name: "HNS Fuel", code: "HNS Fuel", desc: "HNS Fuel" },
    { id: 2, name: "RK Fuels", code: "RK Fuels", desc: "RK Fuels" },
  ];
  //fuel history
  // eslint-disable-next-line
  const [getFuelHistory, setFuelHistory] = useState([]);
  // console.log(">>getFuelHistory",getFuelHistory)
  const [getTripHistory, setTripHistory] = useState([]);
  const detailedPage = (transportNr) => {
    dispatch(addTransportNr(transportNr));
    navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_DETAILS);
  };

  const tripHistoryColumn = [
    {
      name: "Trip Nr",
      selector: (row) => row.documentNumber || "--",
      // sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.documentNumber)}
        >
          {row.documentNumber || "-"}{" "}
        </button>
      ),
      width: "130px",
    },

    {
      name: "Created On",
      selector: (row) => formatDateTime(row.createdAt),
      sortable: true,
      width: "160px",
    },
    {
      name: "Expiry Date",
      cell: (row) => (
        <>
          <div>
            <p className="p-0 m-0">{formatDate(row?.expiryDate)} </p>
          </div>
        </>
      ),
      width: "160px",
    },
    {
      name: "Truck/Driver",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row?.transportrequestDetails?.vehicleNr || row?.vehicleNr}
          </p>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.driverName1}</p>
        </div>
      ),
      selector: (row) => row?.senderCustomerName,
      // sortable: true,
      width: "150px",
    },

    {
      name: "Delivery Status",
      cell: (row) => (
        <>
          <TableStatusField status={row?.deliveryAckStatus || "--"} />
        </>
      ),

      width: "220px",
    },
    {
      name: "Payment Status",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-success-status">
            {row?.paymentStatus || "--"}
          </span>
        </>
      ),

      width: "200px",
    },
    {
      name: "E-Waybill",
      cell: (row) => (
        <>
          <div>
            <p className="p-0 m-0 fw-medium">{row?.ewayBillNumber || "--"} </p>
            <p className="p-0 m-0">{formatDate(row?.ewayBillExpiryDate)} </p>
            <p className="p-0 m-0">{row?.ewayBillExpiryTime} </p>
          </div>
        </>
      ),
      width: "180px",
    },
    {
      name: "Invoice",
      cell: (row) => (
        <>
          <div>
            <p className="p-0 m-0 fw-medium">{row?.vendorInvoiceNo || "--"} </p>
            <p className="p-0 m-0">{formatDate(row?.vendorInvoiceDate)} </p>
          </div>
        </>
      ),
      width: "180px",
    },
    {
      name: "Transfer",
      cell: (row) => (
        <>
          <div>
            <p className="p-0 m-0">{row?.transferTypeDesc} </p>
          </div>
        </>
      ),
      width: "160px",
    },

    {
      name: "Invoice",
      cell: (row) => (
        <>
          {(row.invoiceData && (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() =>
                handleViewFile(row.invoiceData[0]?.purchaseOrderFileAttachment)
              }
            />
          )) ||
            "--"}
        </>
      ),
      width: "130px",
    },

    {
      name: "Sender",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">
            {row?.senderCustomerName || row?.senderCustomerName}
          </span>
        </>
      ),
      selector: (row) => row?.senderCustomerName,
      // sortable: true,
      width: "300px",
    },

    {
      name: "Receiver",
      selector: (row) => row?.reciverCustomerName || "--",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row?.reciverCustomerName} </p>
          {/* <p className="m-0 p-0 fw-bold">{row?.reciverCustomerName} </p> */}
        </div>
      ),
      // sortable: true,
      width: "300px",
    },
  ];
  const fuelHistoryColum = [
    {
      name: "Fuel No",
      selector: (row) => row?.documentNumber,
      cell: (row) => (
        <>
          <span class="bg-table-status bg-table-new-status">
            {row.documentNumber}
          </span>
        </>
      ),
      sortable: true,
      width: "180px",
    },
    {
      name: "Filled Date",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">
            {formatDate(row?.filledDate)}{" "}
          </p>
        </div>
      ),
      width: "140px",
    },
    {
      name: "Truck Nr",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row?.truckNo}</p>
        </div>
      ),
      width: "140px",
    },
    {
      name: "Bunk",
      selector: (row) => row.bunk || "--",
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 text-primary fw-bold">{row.bunk} </p>
          {/* <p className="m-0 p-0">{row.vendorName} </p> */}
        </div>
      ),
    },
    {
      name: "Driver",
      selector: (row) => row.driverName,
      sortable: true,
      width: "100px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.driverName} </p>
          {/* <p className="m-0 p-0">{row.vendorName} </p> */}
        </div>
      ),
    },
    {
      name: "Driver Contact",
      selector: (row) => row.driverContactNr || "--",
      sortable: true,
      width: "150px",
    },

    {
      name: "Liters",
      selector: (row) => row.liters || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Total Amount",
      selector: (row) => row.totalAmount || "--",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-bold">{row.totalAmount}</p>
            {/* <p className="m-0 p-0">{row.currencyCode}</p> */}
          </div>
        </>
      ),
      sortable: true,
      width: "150px",
    },

    {
      name: "Payment Mode",
      selector: (row) => row.paymentMode || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Old Reading",
      selector: (row) => row.oldReading || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "New Reading",
      selector: (row) => row.newReading,
      sortable: true,
      width: "130px",
    },
    {
      name: "Usage Reading",
      selector: (row) => row.usageReading,
      sortable: true,
      width: "140px",
    },
    {
      name: "Mileage",
      selector: (row) => Number(row.mileage).toFixed(2),
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {Number(row.mileage).toFixed(2)}
          </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Attachments",
      selector: (row) => row.billDocument,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center"
        >
          {row.billDocument && (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row.billDocument)}
            />
          )}
        </div>
      ),
      sortable: true,
      width: "130px",
    },
  ];

  // For Upload Success
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  useEffect(() => {
    if (!getDropdownData) return;
    // console.log(">>getDropdownData1", getDropdownData);
    const updatedFields = {
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.textCode,
      [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    };

    if (getDropdownData?.textField === "type") {
      updatedFields.type = getDropdownData?.name;
      updatedFields.type = getDropdownData?.name;
    }
    // if (getDropdownData?.textField === "bunk") {
    //   updatedFields.bunk = getDropdownData?.name;
    //   updatedFields.bunk = getDropdownData?.name;
    // }
    if (getDropdownData?.textField === "paymentMode") {
      updatedFields.paymentMode = getDropdownData?.name;
      updatedFields.paymentMode = getDropdownData?.name;
    }
    if (getDropdownData?.textField === "driverName") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        getDriveBankDetails: getDropdownData?.bandkDetails,
        customer: getDropdownData?.code,
        customerCode: getDropdownData?.id,
        customerCodeDesc: getDropdownData?.name,
        driverBankAccountNumber:
          getDropdownData?.bandkDetails[0]?.bankAccountNumber,
        driverBankAccountName:
          getDropdownData?.bandkDetails[0]?.bankAccountName,
        driverBankKey: getDropdownData?.bandkDetails[0]?.bankKey,
        driverContactNr: getDropdownData?.mobileNr,
      }));
      // setDriveBankDetails(getDropdownData?.bandkDetails);
      setDriverName1Desc(getDropdownData?.id);
    }

    setFormInputs((prev) => ({
      ...prev,
      ...updatedFields,
    }));
    // eslint-disable-next-line
  }, [getDropdownData]);
  useEffect(() => {
    // console.log(">>getDropdownData2", getDropdownData);
    if (getDropdownData?.textCode === "bunk") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.id,
      }));
    }
    setValidation((prev) => ({
      ...prev,
      [getDropdownData?.textField]: "",
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);

  //Validations
  const [validation, setValidation] = useState({
    filledDate: "",
    truckNo: "",
    driverName: "",
    driverContactNr: "",
    bunk: "",
    fuelType: "",
    paymentMode: "",
    liters: "",
    price: "",
    odometerReading: "",
    km: "",
    mileage: "",
    billDocument: "",
    totalAmount: "",
    oldReading: "",
    newReading: "",
    usageReading: "",
  });
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const handleInputChange = ({ target: { name, value } }) => {
    // Real-time validation
    let error = "";
    switch (name) {
      case "truckNo":
        if (!validateRequired(value)) error = message.FILL_REQUIRED_FIELD;
        break;
      case "driverName":
        if (!validateName(value)) error = message.VALID_CUSTOMER_NAME;
        break;
      case "liters":
      case "price":
      case "oldReading":
      case "newReading":
      case "km":
        if (!isValidNumber(value)) error = message.FILL_REQUIRED_FIELD;
        break;
      case "driverContactNr":
        if (!validateContactNumber(value)) error = message.VALID_CONTACT_NUMBER;
        break;
      default:
        break;
    }

    // Update form input values
    setFormInputs((prevInputs) => {
      const updatedInputs = { ...prevInputs, [name]: value };

      // if (updatedInputs.liters && updatedInputs.price) {
      //   updatedInputs.totalAmount =
      //     Number(updatedInputs.liters) * Number(updatedInputs.price);
      // } else {
      //   updatedInputs.totalAmount = "";
      // }

      if (updatedInputs.liters && updatedInputs.totalAmount) {
        updatedInputs.price = (
          Number(updatedInputs.totalAmount) / Number(updatedInputs.liters)
        ).toFixed(2);
      } else {
        updatedInputs.price = "";
      }

      if (updatedInputs.oldReading && updatedInputs.newReading) {
        updatedInputs.usageReading =
          Number(updatedInputs.newReading) - Number(updatedInputs.oldReading);
      } else {
        updatedInputs.usageReading = "";
      }

      if (updatedInputs.usageReading && updatedInputs.liters) {
        updatedInputs.mileage =
          Number(updatedInputs.usageReading) / Number(updatedInputs.liters);
      } else {
        updatedInputs.mileage = "";
      }

      return updatedInputs;
    });

    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  useEffect(() => {
    const price = Number(formInputs?.price);

    if (!isNaN(price) && price <= 800) {
      setValidation((prev) => {
        // If no error already, avoid unnecessary re-render
        if (!prev.price) return prev;

        const { price, ...rest } = prev;
        return rest; // removes price error completely
      });
    }
  }, [formInputs?.price]);

  const initialState = {
    truckNo: "",
    driverName: "",
    driverContactNr: "",
    bunk: "",
    type: "",
    paymentMode: "",
    liters: "",
    price: "",
    totalAmount: "",
    // odometerReading: "",
    km: "",
    mileage: "",
    billDocument: "",
    oldReading: "",
    newReading: "",
    usageReading: "",
  };

  const [getShowFailurePriceModal, setShowFailurePriceModal] = useState(false);
  //handle cancel modal

  const handleSave = async () => {
    if (getOldreadingValidation === true) {
      alert(`Invalid previous reading . previous reading ${maxOldReading}. `);
      setFormInputs((prev) => ({
        ...prev,
        oldReading: maxOldReading,
      }));
      return;
    }
    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== "",
    );
    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      return;
    }
    if (!validateRequired(formInputs.truckNo)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        truckNo: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.driverName)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        driverName: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    // if (!validateName(formInputs.driverName)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureFuelEntry(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     driverName: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    if (!validateRequired(formInputs.driverContactNr)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        driverContactNr: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateContactNumber(formInputs.driverContactNr)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        driverContactNr: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.liters)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        liters: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.liters)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        liters: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (Number(formInputs?.price) > 800) {
      const message =
        "Some trip history is missing and the fuel price should not exceed 800.";
      requiredFields.push(message);
      setErrorFields(requiredFields);
      setShowFailurePriceModal(true);

      setValidation((prev) => ({
        ...prev,
        price: message,
      }));

      return;
    }

    // if (!validateRequired(formInputs?.price)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureFuelEntry(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     price: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!isValidNumber(formInputs.price)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureFuelEntry(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     price: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    if (!validateRequired(formInputs.oldReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        oldReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (!isValidNumber(formInputs.oldReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        oldReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!validateRequired(formInputs.newReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        newReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    if (!isValidNumber(formInputs.newReading)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        newReading: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }
    // if (!validateRequired(formInputs.km)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureFuelEntry(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     km: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    if (!isValidNumber(formInputs.km)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureFuelEntry(true);
      setValidation((prev) => ({
        ...prev,
        km: message.FILL_REQUIRED_FIELD,
      }));
      return;
    }

    if (Number(formInputs?.newReading) < Number(formInputs?.oldReading)) {
      toast.error(
        `Previous reading ${formInputs?.oldReading} cannot be lower than current reading ${formInputs?.newReading}!`,
        {
          position: "top-right",
          autoClose: 5000,
        },
      );
      return;
    }

    setFormInputs((prev) => ({
      ...prev,
      ...initialState,
      // getDriveBankDetails,
      driverName1Desc,
    }));

    let obj = {
      data: formInputs,
    };

    setDisabled(true);
    await ItemServiceV2.addLogisticsFuel(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        navigate(LogisticsConstants?.LOGISTICS_FUEL_ENTRY_LIST);
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };
  //
  const callFuelEntryApi = async () => {
       if (Number(formInputs?.newReading) < Number(formInputs?.oldReading)) {
      toast.error(
        `Previous reading ${formInputs?.oldReading} cannot be lower than current reading ${formInputs?.newReading}!`,
        {
          position: "top-right",
          autoClose: 5000,
        },
      );
      return;
    }
    let obj = {
      data: formInputs,
    };
    console.log(">>obj", obj);
      setDisabled(true);
    await ItemServiceV2.addLogisticsFuel(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        navigate(LogisticsConstants?.LOGISTICS_FUEL_ENTRY_LIST);
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };

  const hideFailureModal = () => {
    setShowFailureFuelEntry(false);
  };
  

  const hideFailureModalPrice = () => {
    setShowFailurePriceModal(false);
    // navigate(LogisticsConstants?.LOGISTICS_FUEL_ENTRY_LIST);
  };


  const [getTruckData, setTruckData] = useState();
  const [getDriverNames, setDriverNames] = useState();

  const loadData = async () => {
    let obj3 = {
      queryName: "get_vehicleRegistrationNr",
    };
    await ItemServiceCustomer.generateCustomerQuery(obj3).then((item) => {
      // console.log(">> item! title", item?.data);

      if (item?.status === 200 && Array.isArray(item?.data)) {
        // Map API data into the desired structure
        const formattedData = item.data.map((truck) => ({
          vehicleRegistrationNr: truck.vehicleRegistrationNr,
          id: truck.id,
          name: truck.name,
          code: truck.vehicleRegistrationNr,
          codeType: truck.vehicleRegistrationNr,
          description: truck.vehicleRegistrationNr,
        }));

        // Append "OTHERS" object
        const updatedData = [
          ...formattedData,
          {
            vehicleRegistrationNr: "000 - OTHERS",
            id: "000",
            name: "000 - OTHERS",
            codeType: "truckCode",
            code: "000",
            description: "OTHERS",
          },
        ];

        setTruckData(updatedData);
      } else {
        setTruckData([]);
        console.log(">> Error: Loading Company Code");
      }
    });

    let obj2 = {
      queryName: "get_driver_list",
    };
    await ItemServiceCustomer.generateCustomerQuery(obj2).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setDriverNames(item.data || []);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  useEffect(() => {
    loadData();
  }, []);
  // eslint-disable-next-line
  const [tripLoading, setTripLoading] = useState(false);
  // eslint-disable-next-line
  const [fuelLoading, setFuelLoading] = useState(false);

  useEffect(() => {
    if (!formInputs?.truckNo) {
      setTripHistory([]);
      setFuelHistory([]);
      return;
    }

    const loadTripData = async () => {
      setTripLoading(true);
      try {
        const obj4 = {
          queryName: "getLogisticsTransportList",
          rowFilter: {
            $and: [
              {
                vehicleNr: formInputs.truckNo,
              },
            ],
          },
          page: 1,
          per_page: 10, // API can return more, UI will limit
        };

        const item = await ItemServiceCustomer.generateCustomerQuery(obj4);

        if (item?.status === 200) {
          // 👉 take only first 5 records
          const firstFive = (item.data || []).slice(0, 5);
          setTripHistory(firstFive);
          // console.log(firstFive[0]?.oldReading)
        } else {
          setTripHistory([]);
        }
      } catch (error) {
        console.error("Trip API error:", error);
        setTripHistory([]);
      } finally {
        setTripLoading(false);
      }
    };

    const loadFuelData = async () => {
      setFuelLoading(true);
      try {
        const obj2 = {
          queryName: "getFuelList",
          rowFilter: {
            $and: [
              {
                truckNo: formInputs.truckNo,
              },
            ],
          },
          page: 1,
          per_page: 10, // backend can return more
        };

        const item = await ItemServiceCustomer.generateCustomerQuery(obj2);

        if (item?.status === 200) {
          // 👉 take first 5 records only
          const firstFive = (item.data || []).slice(0, 5);
          setFuelHistory(firstFive);
          setFormInputs({
            ...formInputs,
            oldReading: firstFive[0]?.newReading,
          });
        } else {
          setFuelHistory([]);
        }
      } catch (error) {
        console.error("Fuel API error:", error);
        setFuelHistory([]);
      } finally {
        setFuelLoading(false);
      }
    };

    loadFuelData();
    loadTripData();
    // eslint-disable-next-line
  }, [formInputs?.truckNo]);

  useEffect(() => {
    if (!formInputs?.truckNo) return;

    const fetchOldReading = async () => {
      setFuelLoading(true);
      try {
        const obj2 = {
          queryName: "ValidateFuelReading",
          truckNo: formInputs?.truckNo,
          oldReading: formInputs?.oldReading,
        };

        const item = await ItemServiceCustomer.generateCustomerQuery(obj2);
        // console.log(">>item",item)
        if (item?.status === 200) {
          const maxReading = item?.data?.[0]?.maxOldReading ?? 0;
          const validate = item?.data?.[0]?.validate;
          setMaxOldReading(maxReading);
          setOldreadingValidation(validate);
        } else {
          setMaxOldReading(null);
        }
      } catch (error) {
        console.error("Fuel API error:", error);
        setMaxOldReading(null);
      } finally {
        setFuelLoading(false);
      }
    };

    fetchOldReading();
  }, [formInputs?.truckNo, formInputs?.oldReading]);
  //curent date
  // const currentDate = new Date().toISOString().split("T")[0];

  const today = new Date().toISOString().split("T")[0];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Fuel Entry </h2>
                <p className="subText">Fuel Entry </p>
              </Col>
            </Row>
            <hr />

            {/* user list */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    {/* <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                             <i
                               className={`bi ${
                                 isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                               }`}
                               onClick={toggleCardVisibility3}
                             ></i>
                           </Col> */}
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">FE</span>
                    </Col>

                    <Col xs={4} md={4} lg={4}>
                      <span className="headerTitle"> Fuel Entry</span>
                      <span className="subHeaderTitle">Fuel Entry details</span>
                    </Col>
                  </Row>
                </h2>

                <div>
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                type="date"
                                label="Filling Date"
                                min="1990-01-01"
                                max={today}
                                name="filledDate"
                                id="filledDate"
                                value={formInputs?.filledDate}
                                onChange={handleInputChange}
                              />
                            </Col>
                            {(formInputs?.truckNo !== "000" ||
                              formInputs?.truckNo !== "") && (
                              <Col
                                xs={12}
                                md={6}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Truck No"
                                  placeholder=""
                                  data={getTruckData}
                                  id="truckNo"
                                  iconClassName="dropdownIcon"
                                  name="truckNo"
                                  code="truckNoCode"
                                  description="truckNoDesc"
                                  setValue={formInputs?.truckNo || ""}
                                  getvalue={setDropdownData}
                                  required={true}
                                  error={validation.truckNo}
                                />
                              </Col>
                            )}
                            {formInputs?.truckNo === "000" && (
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Truck No"
                                  name="truckNo"
                                  placeholder=""
                                  value={formInputs?.truckNo || ""}
                                  onChange={handleInputChange}
                                  required={true}
                                />
                              </Col>
                            )}
                            {/*  <Col
                                     xs={12}
                                     md={6}
                                     lg={4}
                                     className="commTopButtonRightLeftPadding"
                                   >
                                     <InputField
                                       className="inputBox"
                                       label="Truck No"
                                       placeholder=""
                                       name="truckNo"
                                       id="truckNo"
                                       value={formInputs?.truckNo || ""}
                                       error={validation.truckNo || ""}
                                       onChange={handleInputChange}
                                       // disabled={true}
                                       required={true}
                                     />
                                   </Col> */}
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <ComboboxField
                                label="Driver Name"
                                placeholder=""
                                data={getDriverNames}
                                id="driverName"
                                iconClassName="dropdownIcon"
                                name="driverName"
                                code="driverNameCode"
                                description="driverNameDesc"
                                setValue={formInputs.driverName || ""}
                                getvalue={setDropdownData}
                                required={true}
                                error={validation.driverName}
                              />

                              {/* <InputField
                                       className="inputBox"
                                       label="Driver Name"
                                       placeholder=""
                                       name="driverName"
                                       id="driverName"
                                       error={validation.driverName || ""}
                                       value={formInputs?.driverName || ""}
                                       onChange={handleInputChange}
                                     /> */}
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Driver Contact Nr"
                                placeholder=""
                                name="driverContactNr"
                                id="driverContactNr"
                                error={validation.driverContactNr || ""}
                                value={formInputs?.driverContactNr || ""}
                                onChange={handleInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Bunk Name"
                                placeholder=""
                                data={bunk}
                                id="bunk"
                                iconClassName="dropdownIcon"
                                name="bunk"
                                code="bunkCode"
                                description="bunkDesc"
                                setValue={formInputs?.bunk}
                                getvalue={setDropdownData}
                                required={true}
                                // error={validation.country}
                                // disabled={editMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Fuel Type"
                                placeholder=""
                                data={FuelType}
                                id=""
                                iconClassName="dropdownIcon"
                                name="fuelType"
                                code="fuelTypeCode"
                                description="fuelTypeDesc"
                                setValue={formInputs?.fuelType}
                                getvalue={setDropdownData}
                                required={true}
                                // error={validation.country}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Liters"
                                placeholder=""
                                name="liters"
                                id="liters"
                                error={validation.liters || ""}
                                value={formInputs?.liters || ""}
                                onChange={handleInputChange}
                                required={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Bill Amount"
                                placeholder=""
                                name="totalAmount"
                                id="totalAmount"
                                onChange={handleInputChange}
                                value={formInputs?.totalAmount || ""}
                                disabled={false}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Fuel Price"
                                placeholder=""
                                name="price"
                                id="price"
                                error={validation.price || ""}
                                value={formInputs?.price || ""}
                                onChange={handleInputChange}
                                // required={true}
                                disabled={true}
                              />
                            </Col>

                            {/* <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <ComboboxField
                                label="Payment Mode"
                                placeholder=""
                                data={PaymentMode}
                                id=""
                                iconClassName="dropdownIcon"
                                name="paymentMode"
                                code="paymentMode"
                                description="paymentMode"
                                setValue={formInputs?.paymentMode}
                                getvalue={setDropdownData}
                                required={true}
                                // error={validation.country}
                                // disabled={editMode}
                              />
                            </Col> */}
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Previous Reading"
                                placeholder=""
                                name="oldReading"
                                id="oldReading"
                                error={validation.oldReading || ""}
                                value={formInputs?.oldReading || ""}
                                onChange={handleInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Current Reading"
                                placeholder=""
                                name="newReading"
                                id="newReading"
                                error={validation.newReading || ""}
                                value={formInputs?.newReading || ""}
                                onChange={handleInputChange}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total KMs"
                                placeholder=""
                                name="usageReading"
                                id="usageReading"
                                error={validation.usageReading || ""}
                                value={formInputs?.usageReading || ""}
                                onChange={handleInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Mileage"
                                placeholder=""
                                name="mileage"
                                id="mileage"
                                value={formInputs?.mileage || ""}
                                readOnly={true}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Diesel Shortage"
                                placeholder=""
                                name="dieselShortage"
                                id="dieselShortage"
                                error={validation.dieselShortage || ""}
                                value={formInputs?.dieselShortage || ""}
                                onChange={handleInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={12}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <FileUploadComponent
                                id="billDocument"
                                name="billDocument"
                                label="Supporting Document"
                                allowedTypes={[
                                  "image/png",
                                  "image/jpeg",
                                  "application/pdf",
                                ]}
                                multiple={true} // Change to false for single file selection
                                required={true}
                                onSuccessUpload={onSuccessUploadDocumentType}
                                value={formInputs?.billDocument || ""}
                              />
                            </Col>
                            <Col
                              xs={8}
                              md={2}
                              lg={2}
                              className="commLeftRightPadding"
                            >
                              {(formInputs?.billDocument && (
                                <img
                                  src="assets/img/newIcons/attached-file.png"
                                  className="mt-1 attachmentIcon"
                                  alt="attachments"
                                  onClick={() =>
                                    handleViewFile(formInputs?.billDocument)
                                  }
                                />
                              )) ||
                                "--"}
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* trip history */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TH</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Trip History</span>
                      <span className="subHeaderTitle">
                        Trip History Details{" "}
                      </span>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                                                  <POCollabrationCommonFillter />
                                                </Col> */}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={tripHistoryColumn}
                          data={getTripHistory}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={
                          //   Constants.ROW_PER_PAGE
                          // }
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* fuel histoyr */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible3
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">FH</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Fuel History</span>
                      <span className="subHeaderTitle">
                        Fuel History Details{" "}
                      </span>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                                                  <POCollabrationCommonFillter />
                                                </Col> */}
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible3 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={fuelHistoryColum}
                          data={getFuelHistory}
                          // progressPending={loading}
                          // paginationRowsPerPageOptions={
                          //   Constants.ROW_PER_PAGE
                          // }
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
        <Row className="my-4 ">
          {/* <Col
                             lg={{ span: 2, offset: 8 }}
                             className="d-flex justify-content-end mt-2"
                           >
                             <button
                               className="btnTable btn-danger"
                               onClick={handleCancel}
                               disabled={disabled}
                             >
                               Cancel
                             </button>
                           </Col> */}
          <Col
            lg={{ span: 2, offset: 10 }}
            className="d-flex justify-content-end mt-2"
          >
            <button
              className="btnTable"
              disabled={disabled}
              onClick={handleSave}
            >
              Save
            </button>
          </Col>
        </Row>
      </Row>
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />

      <FuelEnteryFailureModal
        show={getShowFailurePriceModal}
        onHide={() => hideFailureModalPrice()}
        requiredfields={getErrorFields}
        onConfirm={() => {
          setShowFailurePriceModal(false);
          callFuelEntryApi();
        }}
      />

      {/* <FuelEntryModal
        show={modalFuelShowStatus}
        onHide={() => hideModalStatus()}
      /> */}
    </main>
  );
};

export default FuelEntryCreation;
